import { Translation } from '@ps/web-shared-components';
import React from 'react';

import WebpWithFallback from '@swf/components/WebpWithFallback/WebpWithFallback';
import { usePollLobbyData } from '@swf/poker';

import {
  TXTCLI_An_unexpected_error_occurredX,
  TXTWCL_But_donXt_panicX_WeXll_be_righ_ELL
} from './PokerError.messages.json';
import styles from './PokerError.scss';
import backgroundPNG from './assets/background.png';
import background from './assets/background.webp';

export const PokerError: React.FC = () => {
  usePollLobbyData();

  return (
    <div className={styles.container}>
      <Translation {...TXTCLI_An_unexpected_error_occurredX}>
        {(message) => <h2 className={styles.title}>{message}</h2>}
      </Translation>
      <Translation {...TXTWCL_But_donXt_panicX_WeXll_be_righ_ELL}>
        {(message) => <h4 className={styles.subTitle}>{message}</h4>}
      </Translation>
      <WebpWithFallback
        src={background}
        srcFallback={backgroundPNG}
        imageClassName={styles.background}
        imageSize={{ height: 1334, width: 415 }}
      />
    </div>
  );
};

export default PokerError;
